export const TRANSLATIONS_PROVIDERS = 'TRANSLATION_PROVIDERS';
